import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Loader from "@/components/Loader";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [sectionsReady, setSectionsReady] = useState(false);
  const [fontsReady, setFontsReady] = useState(false);
  const [error, setError] = useState(false);
  const [loaderGone, setLoaderGone] = useState(false);

  // Loader only applies to the landing route.
  const isLanding =
    typeof window !== "undefined" && window.location.pathname === "/";

  // Fonts ready (with a safety cap so we never hang on a slow font request)
  useEffect(() => {
    if (typeof document !== "undefined" && document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => setFontsReady(true));
      const cap = setTimeout(() => setFontsReady(true), 3000);
      return () => clearTimeout(cap);
    }
    setFontsReady(true);
  }, []);

  // Lock background scroll while the loader is visible.
  // Both <html> and <body> must be locked — the root element owns vertical
  // scrolling under the global `overflow-x: hidden` rule.
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const lock = isLanding && !loaderGone;
    html.style.overflow = lock ? "hidden" : "";
    body.style.overflow = lock ? "hidden" : "";
    return () => {
      html.style.overflow = "";
      body.style.overflow = "";
    };
  }, [loaderGone, isLanding]);

  const ready = sectionsReady && fontsReady;

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <Landing
                onReady={() => setSectionsReady(true)}
                onError={() => setError(true)}
              />
            }
          />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>

      {isLanding && !loaderGone && (
        <Loader
          ready={ready}
          error={error}
          onFinish={() => setLoaderGone(true)}
          onRetry={() => window.location.reload()}
        />
      )}

      <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
